import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueCompositionAPI from "@vue/composition-api";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
// import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { setupInterceptors } from "@/utils/httpInterceptors";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@/core/plugins/vee-validate";
import "@mdi/font/css/materialdesignicons.css";

import SubmitButton from "@/components/button/SubmitButton";
import NoData from "@/components/general/NoData";

Vue.component("submit-button", SubmitButton);
Vue.component("no-data", NoData);

import { ClientTable } from "vue-tables-2";
import GenericFilter from "@/components/vue-table/GenericFilter";

Vue.use(ClientTable, {}, false, "bootstrap4", {
  genericFilter: GenericFilter
});

Vue.use(VueCompositionAPI);

// API service init
ApiService.init();

// Remove this to disable mock API
// MockService.init();

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  created() {
    setupInterceptors(store);
  },
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
